var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaveYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 92,
    viewBox: "0 0 200 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M0 2C0 0.895429 0.895431 0 2 0L198 0C199.105 0 200 0.89543 200 2V79.9348C200 79.9348 158.173 52.7882 100 79.9348C41.8269 107.081 0 79.9348 0 79.9348L0 2Z",
    fill: "#FFCA1D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaveYellow);
export default __webpack_public_path__ + "static/media/wave_yellow.7fdb48d9c3712e0c4f770e11e325bdef.svg";
export { ForwardRef as ReactComponent };